// // import React from 'react';
// // import { Icon, IconProps } from '@chakra-ui/react';

// // interface SectionIconProps extends IconProps {
// //   color?: string;
// // }

// // const SectionIcon: React.FC<SectionIconProps> = ({ color = '#062753', ...props }) => {
// //   return (
// //     <Icon viewBox="0 0 72 65" {...props}>
// //       <path
// //         d="M32.6397 10.7707C22.3209 10.7707 13.2101 14.2663 7.2604 19.6838C2.802 23.4356 0.158813 28.9251 0 34.7628C0 40.6189 2.85276 45.9849 7.5945 50.1513C8.87953 51.2864 7.13183 58.4711 2.95556 63.3469C2.73364 63.6115 2.7674 64.0065 3.03094 64.2293C3.17381 64.35 3.36304 64.4002 3.54667 64.3659C16.1142 62.7278 20.9588 57.1941 21.7298 57.4005C25.294 58.3182 28.96 58.7776 32.6397 58.7678C50.674 58.7678 65.2793 48.0185 65.2793 34.7628C65.2793 21.5155 50.6686 10.7707 32.6397 10.7707ZM36.6265 48.0383C36.6555 49.1015 36.2073 50.1215 35.4055 50.8168C33.6362 52.2649 31.0966 52.2649 29.3273 50.8168C27.7985 49.4243 27.6838 47.0515 29.071 45.5169C29.1523 45.427 29.2378 45.3412 29.3273 45.2597C31.0974 43.8141 33.6353 43.8141 35.4055 45.2597C36.2073 45.955 36.6555 46.9751 36.6265 48.0383ZM42.6071 30.3912C41.9896 31.5814 41.1727 32.656 40.192 33.5679L37.5817 36.013C36.9092 36.6282 36.3802 37.3848 36.0326 38.2288C35.7152 39.1514 35.5538 40.1209 35.555 41.097H29.0407C29.0407 38.8736 29.2913 37.1171 29.7924 35.8275C30.3046 34.519 31.1417 33.3637 32.2241 32.4715C33.1723 31.7053 34.0318 30.8348 34.7866 29.8763C35.3558 29.1321 35.6632 28.2194 35.6609 27.2812C35.6609 24.9799 34.6745 23.8293 32.7017 23.8293C31.8494 23.8019 31.0328 24.174 30.4923 24.8361C29.9316 25.5073 29.6346 26.412 29.6055 27.5563H21.9118C21.9422 24.5061 22.8995 22.1319 24.7837 20.4337C26.6679 18.7356 29.3093 17.8858 32.708 17.8844C36.0942 17.8844 38.7169 18.6696 40.5762 20.2399C42.4354 21.8102 43.3657 24.0433 43.3671 26.9393C43.3795 28.1331 43.1195 29.3139 42.6071 30.3912ZM67.8108 35.7689C68.8181 22.5967 54.6031 8.19086 32.6397 8.19086C24.2969 8.07883 16.1086 10.4535 9.11083 15.0144C13.9168 6.25601 25.5592 0 39.3603 0C57.3893 0 72 10.7449 72 24.005C71.9564 28.2867 70.4811 32.4296 67.8108 35.7689Z"
// //         fill={color}
// //       />
// //     </Icon>
// //   );
// // };

// // export default SectionIcon;
// import React from 'react';
// import { Icon } from '@chakra-ui/react';

// interface SectionIconProps {
//   color?: string;
//   svgPath?: string;
//   boxSize?: string | number;
//   width?: string | number;
//   height?: string | number;
//   margin?: string | number;
//   marginTop?: string | number;
//   marginBottom?: string | number;
//   marginLeft?: string | number;
//   marginRight?: string | number;
// }

// const defaultPath = `M32.6397 10.7707C22.3209 10.7707 13.2101 14.2663 7.2604 19.6838C2.802 23.4356 0.158813 28.9251 0 34.7628C0 40.6189 2.85276 45.9849 7.5945 50.1513C8.87953 51.2864 7.13183 58.4711 2.95556 63.3469C2.73364 63.6115 2.7674 64.0065 3.03094 64.2293C3.17381 64.35 3.36304 64.4002 3.54667 64.3659C16.1142 62.7278 20.9588 57.1941 21.7298 57.4005C25.294 58.3182 28.96 58.7776 32.6397 58.7678C50.674 58.7678 65.2793 48.0185 65.2793 34.7628C65.2793 21.5155 50.6686 10.7707 32.6397 10.7707ZM36.6265 48.0383C36.6555 49.1015 36.2073 50.1215 35.4055 50.8168C33.6362 52.2649 31.0966 52.2649 29.3273 50.8168C27.7985 49.4243 27.6838 47.0515 29.071 45.5169C29.1523 45.427 29.2378 45.3412 29.3273 45.2597C31.0974 43.8141 33.6353 43.8141 35.4055 45.2597C36.2073 45.955 36.6555 46.9751 36.6265 48.0383ZM42.6071 30.3912C41.9896 31.5814 41.1727 32.656 40.192 33.5679L37.5817 36.013C36.9092 36.6282 36.3802 37.3848 36.0326 38.2288C35.7152 39.1514 35.5538 40.1209 35.555 41.097H29.0407C29.0407 38.8736 29.2913 37.1171 29.7924 35.8275C30.3046 34.519 31.1417 33.3637 32.2241 32.4715C33.1723 31.7053 34.0318 30.8348 34.7866 29.8763C35.3558 29.1321 35.6632 28.2194 35.6609 27.2812C35.6609 24.9799 34.6745 23.8293 32.7017 23.8293C31.8494 23.8019 31.0328 24.174 30.4923 24.8361C29.9316 25.5073 29.6346 26.412 29.6055 27.5563H21.9118C21.9422 24.5061 22.8995 22.1319 24.7837 20.4337C26.6679 18.7356 29.3093 17.8858 32.708 17.8844C36.0942 17.8844 38.7169 18.6696 40.5762 20.2399C42.4354 21.8102 43.3657 24.0433 43.3671 26.9393C43.3795 28.1331 43.1195 29.3139 42.6071 30.3912ZM67.8108 35.7689C68.8181 22.5967 54.6031 8.19086 32.6397 8.19086C24.2969 8.07883 16.1086 10.4535 9.11083 15.0144C13.9168 6.25601 25.5592 0 39.3603 0C57.3893 0 72 10.7449 72 24.005C71.9564 28.2867 70.4811 32.4296 67.8108 35.7689Z`;

// const SectionIcon: React.FC<SectionIconProps> = ({
//   color = '#062753',
//   svgPath = defaultPath,
//   boxSize,
//   width,
//   height,
//   margin,
//   marginTop,
//   marginBottom,
//   marginLeft,
//   marginRight,
// }) => {
//   return (
//     <Icon
//       viewBox="0 0 72 65"
//       boxSize={boxSize}
//       width={width}
//       height={height}
//       margin={margin}
//       marginTop={marginTop}
//       marginBottom={marginBottom}
//       marginLeft={marginLeft}
//       marginRight={marginRight}
//     >
//       <path d={svgPath} fill={color} />
//     </Icon>
//   );
// };

// export default SectionIcon;
// import React from 'react';
// import { Icon, IconProps } from '@chakra-ui/react';

// interface SectionIconProps extends Omit<IconProps, 'color'> {
//   color?: string; // Applies to the <path> fill, not the Chakra Icon color prop
//   svgPath?: string;
// }

// const defaultPath = `M32.6397 10.7707C22.3209 10.7707 ... [TRUNCATED FOR BREVITY]`;

// const SectionIcon: React.FC<SectionIconProps> = ({
//   color = '#062753',
//   svgPath = defaultPath,
//   boxSize,
//   width,
//   height,
//   margin,
//   marginTop,
//   marginBottom,
//   marginLeft,
//   marginRight,
//   ...rest // linter will complain about this unless allowed
// }) => {
//   return (
//     <Icon
//       viewBox="0 0 72 65"
//       boxSize={boxSize}
//       width={width}
//       height={height}
//       margin={margin}
//       marginTop={marginTop}
//       marginBottom={marginBottom}
//       marginLeft={marginLeft}
//       marginRight={marginRight}
//       {...rest}
//       // If allowed: {...rest} to support other Chakra props (e.g., display, flex, role)
//     >
//       <path d={svgPath} fill={color} />
//     </Icon>
//   );
// };

// export default SectionIcon;
import React from 'react';
import { Icon, IconProps } from '@chakra-ui/react';

interface SectionIconProps extends Omit<IconProps, 'color'> {
  color?: string;
  svgPath?: string;
}

export const SectionIcon: React.FC<SectionIconProps> = ({
  color = '#062753',
  svgPath,
  ...props
}) => {
  return (
    <Icon
      viewBox="0 0 53 47"
      boxSize={props.boxSize}
      width={props.width}
      height={props.height}
      margin={props.margin}
      marginTop={props.marginTop}
      marginBottom={props.marginBottom}
      marginLeft={props.marginLeft}
      marginRight={props.marginRight}
      display={props.display}
      position={props.position}
      zIndex={props.zIndex}
      opacity={props.opacity}
      role={props.role}
      alignItems={props.alignItems}
      alignSelf={props.alignSelf}
      textAlign={props.textAlign}
    >
      <path d={svgPath} fill={color} />
    </Icon>
  );
};
